import ProviderAPI from "@/apis/components/ProviderAPI.js";
import BaseAPIConfig from "@/apis/base/BaseAPIConfig.js"
import commonFn from "@/commons/commonFunction";
import BaseAPIAuthenConfig from "@/apis/base/BaseAPIAuthenConfig.js"

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state: {
        /**
         * Cờ đang xử lý
         */     
        user: {},
        
        userInfor: {},  
        
        listRole: {},
        
        userOptions: {}
    },

  getters:{
  },  
	mutations: {
      /**
       * Cập nhật context
       * @param {*} state
       * @param {*} payload
       */
      updateContext(state, userData) {
        state.userInfor = {...userData};
      },
    },
	actions: {
        /**
         * Lấy thông tin config cho client làm việc
         * @param {*} context
         */
        async getContextData(context, param) {
          return new Promise((resolve, reject) => {
            ProviderAPI.login(param)
              .then((res) => {
                
                if(res?.data?.Status && res?.data?.Data){

                  const provider = JSON.parse(res.data.Data)
                  BaseAPIConfig.interceptors.request.use(function (config) {
                      config.headers.Authorization =  `Bearer ${provider.AccessToken}`;
                  
                      return config;
                  });
                  
                  BaseAPIAuthenConfig.interceptors.request.use(function (config) {
                      config.headers.Authorization =  `Bearer ${provider.AccessToken}`;
                  
                      return config;
                  });

                  context.commit("updateContext", provider.User);
                  
                }
                resolve(res?.data)
              })
              .catch((err) => {
                reject(err)
              })
          })
        },

        async loginMisaId(context, param){
          return new Promise((resolve, reject) => {
            ProviderAPI.loginMisaId(param)
              .then((res) => {
                if(res?.data?.Status){
                  const provider = JSON.parse(res.data.Data)
                  BaseAPIConfig.interceptors.request.use(function (config) {
                      config.headers.Authorization =  `Bearer ${provider.AccessToken}`;
                  
                      return config;
                  });
                  
                  BaseAPIAuthenConfig.interceptors.request.use(function (config) {
                      config.headers.Authorization =  `Bearer ${provider.AccessToken}`;
                  
                      return config;
                  });

                  context.commit("updateContext", provider.User);
                }
                resolve(res?.data)
              })
              .catch((err) => {
                reject(err)
              })
          })
        },

        async confirmOtpMisaId(context, param){
          return new Promise((resolve, reject) => {
            ProviderAPI.confirmOtpMisaId(param)
              .then((res) => {
                if(res?.data?.Status){
                  const provider = JSON.parse(res.data.Data)
                  BaseAPIConfig.interceptors.request.use(function (config) {
                      config.headers.Authorization =  `Bearer ${provider.AccessToken}`;
                  
                      return config;
                  });
                  
                  BaseAPIAuthenConfig.interceptors.request.use(function (config) {
                      config.headers.Authorization =  `Bearer ${provider.AccessToken}`;
                  
                      return config;
                  });

                  context.commit("updateContext", provider.User);
                }
                resolve(res?.data)
              })
              .catch((err) => {
                reject(err)
              })
          })
        },

        /**
         * Lấy thông tin config cho client làm việc
         * @param {*} context
         */
        async savePassword(context, param) {
          return new Promise((resolve, reject) => {
            ProviderAPI.changePassword(param)
              .then((res) => { 
                if(res?.data?.Status && res?.data?.Data){
                  resolve(res)
                }
                resolve(res)
              })
              .catch((err) => {
                reject(err)
              })
          })
        }
    }
};
